import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "Components/ui/card";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";

const COLORS = ["#4B7A8E", "#D4A017"];

export default function CustomerInsightsPanel({ data }) {
  if (!data) return null;

  const uniqueOrders = data.unique_orders ?? 0;
  const repeatedOrders = data.repeated_customer_orders ?? 0;
  const chartData = [
    { name: "Unique", value: uniqueOrders || 1 },
    { name: "Repeated", value: repeatedOrders || 0 },
  ];

  return (
    <Card>
      <CardHeader>
        <CardTitle style={{ fontSize: "16px" }}>Customer Insights</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="row g-3">
          <div className="col-6">
            <p style={{ fontFamily: "inter-regular", fontSize: "12px", color: "#8A9BA8" }}>Daily New</p>
            <h4 style={{ fontFamily: "Aenoik-medium", fontSize: "24px" }}>{data.daily_new_customers ?? 0}</h4>
          </div>
          <div className="col-6">
            <p style={{ fontFamily: "inter-regular", fontSize: "12px", color: "#8A9BA8" }}>This Month</p>
            <h4 style={{ fontFamily: "Aenoik-medium", fontSize: "24px" }}>{data.new_customers_this_month ?? 0}</h4>
          </div>
          <div className="col-6">
            <p style={{ fontFamily: "inter-regular", fontSize: "12px", color: "#8A9BA8" }}>Unique Orders</p>
            <h4 style={{ fontFamily: "Aenoik-medium", fontSize: "24px" }}>{uniqueOrders}</h4>
          </div>
          <div className="col-6">
            <p style={{ fontFamily: "inter-regular", fontSize: "12px", color: "#8A9BA8" }}>Repeated</p>
            <h4 style={{ fontFamily: "Aenoik-medium", fontSize: "24px" }}>{repeatedOrders}</h4>
          </div>
        </div>
        <div style={{ width: "100%", height: 160, marginTop: "16px" }}>
          <ResponsiveContainer>
            <PieChart>
              <Pie
                data={chartData}
                cx="50%"
                cy="50%"
                innerRadius={40}
                outerRadius={65}
                paddingAngle={3}
                dataKey="value"
              >
                {chartData.map((_, index) => (
                  <Cell key={index} fill={COLORS[index]} />
                ))}
              </Pie>
            </PieChart>
          </ResponsiveContainer>
        </div>
        <div className="d-flex justify-content-center gap-4" style={{ fontSize: "12px", fontFamily: "inter-regular" }}>
          <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <span style={{ width: 8, height: 8, borderRadius: "50%", background: "#4B7A8E", display: "inline-block" }} /> Unique
          </span>
          <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <span style={{ width: 8, height: 8, borderRadius: "50%", background: "#D4A017", display: "inline-block" }} /> Repeated
          </span>
        </div>
      </CardContent>
    </Card>
  );
}
